import React from "react";

import Routes from "./routes";
import "./globalStyle.css";

function App() {
  return <Routes />;
}

export default App;
